import { takeLatest, call, put, select } from 'redux-saga/effects';
import axios from 'axios';
import {
  toolsListRequest,
  toolsListSuccess,
  toolsListFailure,
} from '../reducers/contentList';
import { authUserFailure } from '../reducers/login';
import { API_LINK } from '../../constants';
import {selectedProgram, selectedProgramId, selectedtoolsId, selectedtools, selectedVersionId, getSelectedThinktool} from '../selectors'

const API = `${API_LINK}api/user`;

function* toolsListAxios() {
  const state = yield select(fullState => fullState);
  const { selectedProgramId, selectedModuleId } = state.userProgramsFullReducer;
  const {   user: { userId },
  token } = state.loginReducer;

  const response = yield call(() =>
    axios({
      method: 'get',
      url: `${API}/${userId}/allTools?program_id=${selectedProgramId}`,
      headers: {
        'Access-Control-Allow-Origin': '*',
        'tools-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        Authorization: `Bearer ${token}`,
      },
    }),
  );

  return response;
}

function* workerToolsListSaga() {
  try {
   
    const response = yield call(toolsListAxios);

    const responseFromtoolsList = response.data;
    
    yield put(toolsListSuccess(responseFromtoolsList.data.components[0].content));

    if (response.status === 500) {
      yield put(authUserFailure(response));
    }
  } catch (error) {
    
    yield put(toolsListFailure(error.response));
  }
}

export function* watcherToolsListSaga() {
  yield takeLatest(toolsListRequest().type, workerToolsListSaga);
}
